import React from "react";
const PageNotFound: React.FC = () => {

    return (
        <div className="page-not-input">
            <h1 className="color">Oops!!</h1>
            <span className="text-spacing">Page not found.</span>
        </div>
    );
}
export default PageNotFound;